import i18n from './shared/i18n';
import Vue from 'vue';
import '@babel/polyfill';
import './core/filters/GeneralFilters';
import './core/directives';
import "./plugins";
import './modules/modules.js';
import router from './shared/router';
import {store} from './plugins/vuex'
import App from './App.vue';

Vue.config.productionTip = false;
new Vue({i18n, router, store, render: h => h(App)}).$mount('#app');
